<template>
    <div>
        <!-- <div>
      <ContactMainSection titleM="Kontakt" tekst1M="Udruženje studenata elektrotehnike Evrope" tekst2M="Upravni Odbor" background="uo/uo.jpg"/>
    </div> -->
        <div>
            <img
                class="ilustracijaKontakt"
                id="hramSava"
                src="../assets/ilustrations/hramR.png"
                alt="hramSava"
            />
            <img
                class="ilustracijaKontakt"
                id="crkvaR"
                src="../assets/ilustrations/crkvaR.png"
                alt="crkvaR"
            />
            <img
                class="ilustracijaKontakt"
                id="kalemegdan1"
                src="../assets/ilustrations/mesto3b.png"
                alt="kalemegdan1"
            />
        </div>

        <!-- Kontakti UO -->
        <div class="Chairperson">
            <ContactCard
                position="Predsednik udruženja - Lana Jovičić"
                email="chairperson@eestec.etf.rs"
                phone="+381 69 3940252"
                imageName="uo/chair.jpg"
            />
        </div>
        <div class="positionPanel">
            <ContactCard
                position="Kontakt osoba - Anđela Janković"
                email="cp@eestec.etf.rs"
                phone="+381 64 0678433"
                imageName="uo/cp.jpg"
            />
            <ContactCard
                position="Odnosi sa privredom - Mihailo Bilbija"
                email="cr@eestec.etf.rs"
                phone="+381 63 337759"
                imageName="uo/cr.jpg"
            />
            <ContactCard
                position="Blagajnik - Ognjen Baić"
                email="treasurer@eestec.etf.rs"
                phone="+381 64 9261434"
                imageName="uo/tr.jpg"
            />
            <ContactCard
                position="Ljudski resursi - Radonja Radonjić"
                email="hr@eestec.etf.rs"
                phone="+381 69 1508011"
                imageName="uo/hr.jpg"
            />
            <ContactCard
                position="Odnosi sa javnošću - Milica Štavljanin"
                email="pr@eestec.etf.rs"
                phone="+381 64 9165061"
                imageName="uo/pr.jpg"
            />
            <ContactCard
                position="IT koordinator - Aleksandar Cvetković"
                email="it@eestec.etf.rs"
                phone="+381 64 8428166"
                imageName="uo/it.jpg"
            />
        </div>
    </div>
</template>

<script>
import ContactCard from "../components/contacts/ContactCard.vue";
import ContactMainSection from "../components/contacts/ContactMainSection.vue";

export default {
    name: "Contact",
    components: {
        ContactCard,
        ContactMainSection,
    },
};
</script>

<style>
.Chairperson {
    margin: 80px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 80px;
}

.ilustracijaKontakt {
    position: absolute;
}

#hramSava {
    left: 20%;
    width: 50%;
    max-width: 775px;
    opacity: 0.25;
}

#crkvaR {
    margin-top: 45%;
    right: 20%;
    width: 40%;
    max-width: 575px;
    opacity: 0.25;
}

#kalemegdan1 {
    margin-top: 61.56%;
    left: 5%;
    width: 40%;
    max-width: 575px;
    opacity: 0.25;
}

.positionPanel {
    margin: 80px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 80px;
    max-width: 1300px;
}
</style>
